import React from "react";

import { DlpPolicyDetails } from "../../layouts/policyDetails/v3/DlpPolicyDetails";

const DlpPolicyDetailsWrapper = (props) => <DlpPolicyDetails {...props} />;

export default DlpPolicyDetailsWrapper;
